export default "__VITE_ASSET__529972bf__"